























import { Vue, Component, Prop } from 'vue-property-decorator';

const { AgGridVue } = require('ag-grid-vue');
import {
  GridOptions,
  GridApi,
  GridReadyEvent,
  ICellRendererParams,
  ColDef,
  ColumnApi,
  CellClickedEvent,
} from 'ag-grid-community';

import { DetalleDispositivosApi } from '../models/BajasComerciales.model';

@Component({ components: { GridComponent: AgGridVue } })
export default class TabDetalle extends Vue {
  @Prop({ required: true, default: [] }) data!: DetalleDispositivosApi[];

  columnApi: any = null;
  gridOptions: GridOptions = null;
  gridEvent: any = null;
  gridApi: GridApi = null;
  columnDefs: ColDef[] = [];
  listData: any = [];
  quickSearch: string = '';

  constructor() {
    super();
    this.columnDefs = this.colsGrid();

    this.gridOptions = {
      columnDefs: this.columnDefs,
      pagination: true,
      paginationPageSize: 25,
      cacheBlockSize: 25,
      overlayNoRowsTemplate: 'No hay filas para mostrar',
      onGridReady: this.handleMainGridReady,
    };
  }

  handleMainGridReady(event: GridReadyEvent): void {
    this.gridApi = event.api;
    this.columnApi = event.columnApi;
    this.gridEvent = event;
    this.gridApi.setRowData(this.data);
    this.gridApi.setDomLayout('autoHeight');
  }

  handleSearch() {
    this.gridApi.setQuickFilter(this.quickSearch);
    this.gridApi.setDomLayout('autoHeight');
  }

  private colsGrid(): ColDef[] {
    const fields = [
      {
        headerName: 'Nombre Línea',
        field: 'nombre_linea',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 220,
        minWidth: 100,
        hide: true,
      },
      {
        headerName: 'EPC',
        field: 'epc',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 140,
        minWidth: 100,
      },
      {
        headerName: 'Serie EP',
        field: 'serie_ep',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 140,
        minWidth: 100,
      },
      {
        headerName: 'Nota de Venta',
        field: 'nota_venta',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 140,
        minWidth: 100,
      },
      {
        headerName: 'Produto ERP',
        field: 'producto_erp',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 140,
        minWidth: 100,
      },
      {
        headerName: 'Producto Comercial',
        field: 'producto_comercial',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 140,
        minWidth: 100,
      },
      {
        headerName: 'Flota',
        field: 'flota',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 140,
        minWidth: 100,
      },
      {
        headerName: 'Telco',
        field: 'telco',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 140,
        minWidth: 100,
      },
      {
        headerName: 'Tipo de Flota',
        field: 'tipo_flota',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 140,
        minWidth: 100,
      },
      {
        headerName: 'Plataforma',
        field: 'plataforma',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 140,
        minWidth: 100,
      },
      {
        headerName: 'Movil',
        field: 'movil',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 140,
        minWidth: 100,
      },
      {
        headerName: 'Sim Card',
        field: 'sim_card',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 140,
        minWidth: 100,
      },
      {
        headerName: 'Estado',
        field: 'estado',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 140,
        minWidth: 100,
      },
      {
        headerName: 'Razon del Estado',
        field: 'razon_estado',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 140,
        minWidth: 100,
      },
      {
        headerName: 'Tarifa Monitoreo',
        field: 'tarifa_monitoreo',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 150,
        minWidth: 100,
      },
      {
        headerName: 'Tarifa Roaming',
        field: 'tarifa_roaming',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 150,
        minWidth: 100,
      },
      {
        headerName: 'Tarifa Nube',
        field: 'tarifa_nube',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 140,
        minWidth: 100,
      },
      {
        headerName: 'Tarifa Route Planner',
        field: 'tarifa_route_planner',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 160,
        minWidth: 100,
      },
      {
        headerName: 'Tarifa Arriendo',
        field: 'tarifa_arriendo',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 150,
        minWidth: 100,
      },
      {
        headerName: 'Tarifa Comodato',
        field: 'tarifa_comodato',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 150,
        minWidth: 100,
      },
      {
        headerName: 'Tarifa Sim Global',
        field: 'tarifa_sim_global',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 160,
        minWidth: 100,
      },
      {
        headerName: 'Tarifa Peaje',
        field: 'tarifa_peaje',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 140,
        minWidth: 100,
      },
      {
        headerName: 'Tarifa Servicio Mantencion',
        field: 'tarifa_servicio_mantencion',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 140,
        minWidth: 100,
      },
      {
        headerName: 'Tarifa Total',
        field: 'tarifa_total',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 140,
        minWidth: 100,
      },
    ];
    return fields;
    /*const fields = [
      'Nombre Línea',
      'EPC',
      'Nota de Venta',
      'Serie EP',
      'Produto ERP',
      'productos Comerciales',
      'Flota',
      'Telco',
      'Tipo de Flota',
      'Plataforma',
      'Movil',
      'Sim Card',
      'Estado',
      'Razon del Estado',
      'Tarifa Monitoreo',
      'Tarifa Roaming',
      'Tarifa Nube',
      'Tarifa Route Planner',
      'Tarifa Arriendo',
      'Tarifa Comodato',
      'Tarifa Sim Global',
      'Tarifa Peaje',
      'Tarifa Servicio Mantencion',
      'Tarifa Total',
    ];*/

    /*return Object.keys(this.data[0])
      .filter(col => !['id', 'id_baja_crm', 'TOTAL_REGISTROS'].includes(col))
      .map((col, i) => ({
        headerName: fields[i],
        field: col,
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 220,
        minWidth: 100,
      }));
      */
  }
}
